<div class="rds-c-variable-details-header">
  <!-- <button
    [attr.aria-label]="_selectionState.tooltip"
    (click)="togglePackage(variable)"
    color="primary"
    mat-raised-button
    [matTooltip]="_selectionState.tooltip"
    matTooltipPosition="below"
  >
    <mat-icon [svgIcon]="_selectionState.svgIcon"></mat-icon>{{ _selectionState.buttonText }}
  </button> -->
  <h2 class="mat-h2">
    <span *ngIf="variable$ | async as variable">{{ variable?.name || variable?.id }}</span>
  </h2>
</div>
<mat-progress-bar *ngIf="isVariableSummary$ | async" color="accent" class="summary-progress" mode="indeterminate"></mat-progress-bar>
<mat-tab-group>
  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon>info</mat-icon>
      <span i18n>Details</span>
    </ng-template>
    <ng-container *ngIf="variable$ | async as v">
      <rds-c-variable-information [variable]="v"> </rds-c-variable-information>
    </ng-container>
  </mat-tab>

  <!-- <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon svgIcon="filter"></mat-icon>
      <span>{{ _textFilter }}</span>
    </ng-template>
    <ng-template matTabContent>
      <div class="filter-tab-content-body">
      <p class="mat-body-1 filter-instructions" i18n>Multiple filters for each variable will be joined with the logical OR operator.</p>
      <mat-divider class="filter-divider"></mat-divider>

      <p class="mat-body-2" i18n>Null Filter</p>
      <p class="mat-caption sub-text" i18n>Specifically include or exclude <em>Empty/SysMiss/Null</em> values</p>
      <rds-c-null-filter [(ngModel)]="_nullFilter" (ngModelChange)="_determineIfFilterHasChanged()"></rds-c-null-filter>

      <mat-divider class="filter-divider"></mat-divider>

      <ng-container [ngSwitch]="_filterType">
        <ng-template ngSwitchCase="CODE">
          <ng-container *ngIf="variable?.classificationUri">
            <p class="mat-body-2" i18n>Code Filter</p>
            <rds-c-filter
              [codes]="codes"
              [enablePagination]="true"
              [enableSearch]="true"
              [loading]="loadingClassificationOrCodes$ | async"
              [length]="codeSearchFound$ | async"
              [pageIndex]="codesPageIndex$ | async"
              [pageSize]="codesPageSize$ | async"
              [searchText]="codeSearchText$ | async"
              [selectedCodes]="_codesSelected$ | async"
              (clearSelectedCodes)="handleClearSelectedCodes()"
              (search)="handleCodeSearch($event)"
              (selectCode)="handleSelectCode($event)"
              (unselectCode)="handleUnselectCode($event)"
              (pageChange)="handleCodesPageChange($event)"
            ></rds-c-filter>
            <div class="filter-actions" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px">
              <button
                (click)="handleClearFilter(variable, _codesSelected$)"
                [disabled]="(_enableClearFilters$ | async) === false"
                mat-button
              >
                {{ _textClearFilter }}
              </button>
              <button (click)="handleApplyCodeFilter(variable)" color="primary" [disabled]="!_enableApplyFilters" mat-raised-button>
                <span i18n>APPLY FILTER</span>
              </button>
            </div>
          </ng-container>
        </ng-template>
        <ng-template ngSwitchCase="TEXT">
          <p class="mat-body-2" i18n>Text Filter</p>
          <rds-c-text-filter
            [filters]="_textFilters$ | async"
            [largeChips]="true"
            [supportedOperators]="supportedFilters$ | async"
            (add)="handleAddTextFilter($event)"
            (remove)="handleRemoveTextFilter($event)"
          ></rds-c-text-filter>

          <div class="filter-actions" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px">
            <button (click)="handleClearFilter(variable, _textFilters$)" [disabled]="(_enableClearFilters$ | async) === false" mat-button>
              {{ _textClearFilter }}
            </button>
            <button (click)="handleApplyTextFilter(variable)" color="primary" [disabled]="!_enableApplyFilters" mat-raised-button>
              <span i18n>APPLY FILTER</span>
            </button>
          </div>
        </ng-template>
        <ng-template ngSwitchCase="NUMERIC">
          <p class="mat-body-2" i18n>Numeric Filter</p>
          <rds-c-numeric-filter
            [filters]="_numericFilters$ | async"
            [largeChips]="true"
            [supportedOperators]="supportedFilters$ | async"
            (add)="handleAddNumericFilter($event)"
            (remove)="handleRemoveNumericFilter($event)"
          ></rds-c-numeric-filter>

          <div class="filter-actions" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px">
            <button
              (click)="handleClearFilter(variable, _numericFilters$)"
              [disabled]="(_enableClearFilters$ | async) === false"
              mat-button
            >
              {{ _textClearFilter }}
            </button>
            <button (click)="handleApplyNumericFilter(variable)" color="primary" [disabled]="!_enableApplyFilters" mat-raised-button>
              <span i18n>APPLY FILTER</span>
            </button>
          </div>
        </ng-template>
        <ng-template ngSwitchCase="DATE">
          <p class="mat-body-2" i18n>Date Filter</p>
          <rds-c-date-filter
            [filters]="_dateFilters$ | async"
            [largeChips]="true"
            [supportedOperators]="supportedFilters$ | async"
            (add)="handleAddDateFilter($event)"
            (remove)="handleRemoveDateFilter($event)"
          ></rds-c-date-filter>

          <div class="filter-actions" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px">
            <button (click)="handleClearFilter(variable, _dateFilters$)" [disabled]="(_enableClearFilters$ | async) === false" mat-button>
              {{ _textClearFilter }}
            </button>
            <button (click)="handleApplyDateFilter(variable)" color="primary" [disabled]="!_enableApplyFilters" mat-raised-button>
              <span i18n>APPLY FILTER</span>
            </button>
          </div>
        </ng-template>
      </ng-container>
    </div>
    </ng-template>
  </mat-tab> -->
  <mat-tab *ngIf="variable?.classificationUri">
    <ng-template mat-tab-label>
      <mat-icon>toc</mat-icon>
      <span i18n>Codes</span>
    </ng-template>
    <section class="code-table-container">
      <mtna-search-box [debounce]="250" [ngModel]="codesSearchText$ | async" (search)="searchCodes($event)"></mtna-search-box>
      <mat-progress-bar *ngIf="loadingClassificationOrCodes$ | async" mode="indeterminate" color="accent"></mat-progress-bar>
      <rds-c-codes-table
        [codes]="codes$ | async"
        [length]="codesFound$ | async"
        [pageIndex]="codesPageIndex$ | async"
        [pageSize]="codesPageSize$ | async"
        [sortColumnActive]="codesSortColumn$ | async"
        [sortDirection]="codesSortDirection$ | async"
        (pageChange)="paginateCodes($event)"
        (sortChange)="sortCodes($event)"
      ></rds-c-codes-table>
    </section>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon>pie_chart</mat-icon>
      <span i18n>Stats</span>
    </ng-template>
    <ng-template matTabContent>
      <rds-c-variable-stats
        [loadingFrequencyChart]="loadingFrequencyChart$ | async"
        [frequencyChartData]="frequencyChart$ | async"
        [variable]="variable$ | async"
      ></rds-c-variable-stats>
      <ng-template #noStats>
        <p *ngIf="(isVariableSummary$ | async) === false" class="mat-body-2" i18n>No statistics are available for this variable.</p>
      </ng-template>
    </ng-template>
  </mat-tab>
</mat-tab-group>
